<template>
    <div class="fs5-estimated-earns">
        <div class="fs5-earnings-forecast-header" >
            <div class="fs5-earnings-forecast-title" v-html="view.translation.earnings_forecast_title"></div>
            <div class="fs5-earnings-forecast-tooltip">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                    class="icon"
                    data-toggle="tooltip"
                    rel="tooltip2"
                    data-placement="bottom"
                    data-html="true"
                    :data-title="view.translation.earnings_forecast_tooltip"
                >
                    <path d="M8 16C3.589 16 0 12.411 0 8C0 3.589 3.589 0 8 0C12.411 0 16 3.589 16 8C16 12.411 12.411 16 8 16ZM8 1.16C4.228 1.16 1.159 4.2275 1.159 8C1.159 11.7715 4.228 14.84 8 14.84C11.772 14.84 14.841 11.7715 14.841 8C14.841 4.2275 11.772 1.16 8 1.16Z" fill="#0080FC"/>
                    <path d="M8.16495 12.1515C8.10345 12.128 8.03694 12.09 8.03694 11.929C8.03694 11.8625 8.04745 11.7855 8.07094 11.6915L9.08145 6.79301C9.10445 6.67801 9.11595 6.55751 9.11595 6.43751C9.11595 6.12101 9.01794 5.88001 8.82544 5.72051C8.39394 5.36601 7.63895 5.43551 6.38294 5.86001L6.26144 5.90101L6.21144 6.53301H6.42244C7.06144 6.53301 7.21594 6.58301 7.24794 6.59851C7.29095 6.61901 7.31445 6.64351 7.31445 6.71551C7.31445 6.75551 7.30944 6.80051 7.29945 6.85051C7.28645 6.91701 7.27194 6.99401 7.25694 7.07701L6.33094 11.576C6.28794 11.8025 6.26594 11.997 6.26594 12.152C6.26594 12.5105 6.36894 12.7875 6.57144 12.9745C6.77094 13.157 7.04194 13.25 7.37944 13.25C7.77345 13.25 8.30295 13.1405 8.99695 12.916L9.12095 12.876L9.17094 12.2355H8.96044C8.48594 12.2355 8.26645 12.1895 8.16495 12.1515Z" fill="#0080FC"/>
                    <path d="M9.49553 3.02455C9.30453 2.84305 9.05953 2.75005 8.76753 2.75005C8.46503 2.75005 8.20903 2.84955 8.00753 3.04505C7.80453 3.24155 7.70103 3.50605 7.70103 3.83205C7.70103 4.13205 7.79953 4.38105 7.99303 4.57405C8.18703 4.76855 8.43453 4.86705 8.72903 4.86705C9.02853 4.86705 9.28203 4.76255 9.48453 4.55855C9.68553 4.35455 9.78753 4.08955 9.78753 3.77055C9.78753 3.45905 9.68953 3.20805 9.49553 3.02455Z" fill="#0080FC"/>
                </svg>
            </div>
        </div>
        <div class="fs5-earnings-forecast-content">
            <fs5-estimated-earns-card
                v-for="(item, key) in view.cards"
                :key="key"
                :title="item.title"
                :value="item.value"
            />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'fs5-estimated-earns',
        props: ['view'],
        data(){
            return {
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../../scss/extras/_variables';
    .fs5-estimated-earns{
        font: inherit;
        .fs5-earnings-forecast-header{
            font: inherit;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            column-gap: 1.2em;
            .fs5-earnings-forecast-title{
                font: inherit;
                display: inline-block;
                color: $fs5-color4;
                font-size: 2.4em;
                line-height: 1.2;
                font-weight: 700;
            }
            .fs5-earnings-forecast-tooltip{
                font: inherit;
                display: inline-block;
                .icon{
                    font: inherit;
                    color: $fs5-color5;
                    width: 1.6em;
                    height: auto;
                    &:hover{
                        cursor: pointer;
                    }
                }
            }
        }
        .fs5-earnings-forecast-content{
            font: inherit;
            width: 100%;
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-template-rows: auto;
            justify-content: stretch;
            column-gap: 3.6em;

            margin-top: 2.5em;
        }
    }

    @media screen and (max-width: 549px) {
        .fs5-estimated-earns{
            .fs5-earnings-forecast-content{
                grid-template-columns: auto; 
                grid-template-rows: repeat(3, auto);
                row-gap: 1em;
            }
        }
    }
</style>
<style lang="scss">
    @import '../../../../../scss/extras/_variables';
    .fs5-estimated-earns{
        .fs5-earnings-forecast-header{
            .fs5-earnings-forecast-tooltip{
                .tooltip{
                    .tooltip-inner{
                        font-family: $fs5-font2!important;
                        font-size: 14px;
                        padding: 10px!important;
                        border-radius: 4px!important;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/affiliate_dashboard/estimated_earns/index.vue